import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";

import * as firebase from "firebase";

import * as Sentry from "@sentry/browser";

export default action$ =>
  action$.ofType(Types.LOGIN_REQUEST).mergeMap(action =>
    firebase
      .auth()
      .signInWithEmailAndPassword(action.username, action.password)
      .then(() => {
        const { mode, location, username } = action;
        const {
          uid,
          emailVerified,
          photoUrl,
          email,
          name
        } = firebase.auth().currentUser;

        // Save mode and location to local storage.
        localStorage.setItem("mode", mode);
        localStorage.setItem("location", location);
        localStorage.setItem("username", username);

        // Set the Raven user and extra context
        Sentry.setUser({
          email: username,
          mode: mode,
          location: location
        });

        return Creators.loginSucceeded(location, mode, {
          uid,
          emailVerified,
          photoUrl,
          email,
          name
        });
      })
      .catch(error => Creators.loginFailed(error.code, error.message))
  );



// WEBPACK FOOTER //
// ./src/login/epics/loginWithFirebase.js